import { useEffect } from 'react';

import { PhotoMake, PhotoPreview } from '~shared/ui';

import { photoStore } from './photo.store.ts';

type PhotoScreenProps = {
	onCreate: (val: string) => void;
};

export function PhotoScreen({ onCreate }: PhotoScreenProps) {
	const { photo, make, clear } = photoStore();

	useEffect(() => {
		clear();
	}, [clear]);

	if (!photo)
		return (
			<div className="session-page__photo-make">
				<PhotoMake onCreate={make} sellfy={true} />
			</div>
		);
	return (
		<div className="session-page__photo-preview">
			<PhotoPreview photo={photo} onClear={clear} onCreate={onCreate} />
		</div>
	);
}
